import Switch from 'antd/lib/switch';
import Space from 'antd/lib/space';
import Tooltip from 'antd/lib/tooltip';
import * as React from 'react';
import Text from 'antd/lib/typography/Text';
import { runwayColors } from './styles/globalStyles';
import { InfoCircleOutlined } from '@ant-design/icons';
import { SubscriptionFeatureType } from '../types';
import { PlanRestrictedFeatureWrapper } from './planRestrictions/PlanRestrictedFeatureWrapper';

export interface SettingsSwitchRowProps {
    featureType?: SubscriptionFeatureType;
    title: React.ReactNode;
    description: React.ReactNode;
    checked?: boolean;
    onChange?: (checked: boolean) => void;
    isLoading?: boolean;
    tooltipText?: string;
    switchTooltipText?: string;
    disabled?: boolean;
}

export const SettingsSwitchRow: React.FC<SettingsSwitchRowProps> = (props) => {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 24,
                flex: 1,
                minHeight: 80,
            }}
        >
            <Space direction="vertical">
                <Space size={4} align="center">
                    <PlanRestrictedFeatureWrapper feature={props.featureType} requiresTooltip shouldFakeDisabledState>
                        <Text strong>{props.title}</Text>{' '}
                    </PlanRestrictedFeatureWrapper>
                    {props.tooltipText && (
                        <Tooltip title={props.tooltipText}>
                            <InfoCircleOutlined style={{ color: runwayColors.darkTextGrey }} />
                        </Tooltip>
                    )}
                </Space>
                <PlanRestrictedFeatureWrapper feature={props.featureType} shouldFakeDisabledState>
                    <Text type="secondary">{props.description}</Text>
                </PlanRestrictedFeatureWrapper>
            </Space>
            {props.switchTooltipText ?
                <Tooltip title={props.switchTooltipText}>
                    <Switch
                        checked={props.checked}
                        onChange={props.onChange}
                        loading={props.isLoading}
                        disabled={!!props.disabled}
                    />
                </Tooltip>
            :   <Switch
                    checked={props.checked}
                    onChange={props.onChange}
                    loading={props.isLoading}
                    disabled={!!props.disabled}
                />
            }
        </div>
    );
};
